<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-rose card-header-icon">
        <div class="card-icon">
          <i class="material-icons">assignment</i>
        </div>
        <h4 class="card-title">Modifier mes jobs alertes</h4>
      </div>
      <div class="card-body" id="wizardProfile">
        <app-add-edit-form></app-add-edit-form>
        <div class="card-footer">
          <button mat-raised-button type="button" (click)="dialogRef.close(true)" class="btn btn-fill btn-rose">Annuler</button>
          <button mat-raised-button type="button" (click)="onUpdate(this.data.idcandidat_jobalert)" class="btn btn-fill btn-rose">Valider</button>
        </div>
      </div>
    </div>
  </div>
</div>
